import { init, register } from 'svelte-i18n';
import { browser } from '$app/environment';

const defaultLocale = 'fr-FR';

const I18N_OPTIONS = {
	fallbackLocale: defaultLocale,
	initialLocale: browser ? window.navigator.language : defaultLocale,
	warnOnMissingMessages: true
};

register('fr-FR', () => import('./fr.json'));

init(I18N_OPTIONS);
